const translations = {
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    loading: 'Loading...',
    noData: 'No data available',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    close: 'Close',
    add: 'Add',
    update: 'Update',
    view: 'View',
    from: 'From',
    to: 'To',
    date: 'Date',
    status: 'Status',
    actions: 'Actions',
    description: 'Description',
    title: 'Title',
    category: 'Category',
    priority: 'Priority',
    type: 'Type',
    note: 'Note',
    optional: 'optional',
    
    // Auth
    login: 'Log In',
    logout: 'Log Out',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    loginSuccess: 'Login successful!',
    invalidCredentials: 'Invalid credentials',
    systemActive: 'SYSTEM ACTIVE',

    // Sidebar & Nav
    dashboard: 'UA Dashboard',
    myTasks: 'My Tasks',
    ibManagement: 'IB Management',
    teamSpace: 'Team Space',
    settings: 'Settings',
    uaResourceLibrary: 'UA Resource Library',
    announcements: 'Announcements',
    dailyEcstasy: 'Daily Ecstasy',
    ideasBoard: 'Ideas Board',
    anonymousWall: 'Anonymous Wall',
    crmFeedback: 'CRM Feedback',
    creativeRequest: 'Creative Request',
    votingPolls: 'Voting & Polls',
    weeklyStandup: 'Weekly Standup',
    leaderboard: 'Leaderboard',

    // Dashboard
    overallPerformance: 'Overall Performance',
    executiveDashboard: 'Executive Dashboard',
    allIBsCombined: 'All IBs Combined',
    performanceProjections: 'Performance Projections',
    endOfMonthForecast: 'End of Month Forecast',
    keyMetricsScorecard: 'Key Metrics Scorecard',
    baseScenario: 'Base Scenario',
    endOfMonth: 'End of Month',
    current: 'CURRENT',
    target: 'TARGET',
    surplus: 'surplus',
    shortfall: 'shortfall',
    projectedSubscribers: 'Projected Subscribers',
    projectedLeads: 'Projected Leads',
    projectedClosed: 'Projected Closed',
    projectedActiveClient: 'Projected Active Client',
    projectedTradedLot: 'Projected Traded Lot',
    projectedCommissions: 'Projected Commissions',
    totalSpend: 'TOTAL SPEND',
    impressions: 'IMPRESSIONS',
    linkClicks: 'LINK CLICKS',
    lpv: 'LPV',
    ctaClicks: 'CTA CLICKS',
    subscribers: 'SUBSCRIBERS',
    leads: 'LEADS',
    closed: 'CLOSED',
    deposit: 'DEPOSIT',
    signal: 'SIGNAL',
    ibActivity: 'IB ACTIVITY',
    activeClient: 'ACTIVE CLIENT',
    tradedLot: 'TRADED LOT',
    commissions: 'COMMISSIONS',
    roi: 'ROI',
    noDataAvailable: 'No data available',

    // My Tasks
    managePersonalTasks: 'Manage your personal tasks',
    addTask: 'Add Task',
    allTasks: 'All Tasks',
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    tasks: 'Tasks',
    assignedToMe: 'Assigned To Me',
    calendar: 'Calendar',
    month: 'Month',
    list: 'List',
    searchTasks: 'Search tasks...',
    noTasksFound: 'No tasks found',
    noTasksAssigned: 'No tasks assigned to you',
    assignedTasksHint: 'Creative requests assigned to you will appear here',
    noTasksScheduled: 'No tasks scheduled for',
    enterTaskTitle: 'Enter task title',
    optionalDescription: 'Optional description...',
    addNewTask: 'Add New Task',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    general: 'General',
    work: 'Work',
    meeting: 'Meeting',
    personal: 'Personal',
    dueDate: 'Due Date',

    // Daily Ecstasy
    checkInMoodAndQuotes: 'Check in your mood & share inspirational quotes',
    moodCheckIn: 'Mood Check-in',
    howAreYouFeeling: 'How are you feeling today?',
    submitted: 'Submitted',
    addNote: 'Add a note (optional)...',
    submitMood: 'Submit Mood',
    updateMood: 'Update Mood',
    quoteOfTheDay: 'Quote of the Day',
    noQuoteToday: 'No quote selected for today yet',
    shareQuote: 'Share an inspirational quote:',
    enterQuote: 'Enter your quote...',
    teamQuotesToday: 'Team quotes today:',
    selected: 'Selected',
    great: 'Great',
    good: 'Good',
    okay: 'Okay',
    stressed: 'Stressed',
    bad: 'Bad',

    // Announcements
    teamAnnouncements: 'Team Announcements',
    stayUpdated: 'Stay updated with team news',
    newAnnouncement: 'New Announcement',
    pinned: 'Pinned',
    announcementTitle: 'Announcement title',
    writeAnnouncement: 'Write your announcement...',
    pinAnnouncement: 'Pin this announcement',
    post: 'Post',
    noAnnouncements: 'No announcements yet',

    // Creative Request
    orderMaterials: 'Order materials from creative team',
    newRequest: 'New Request',
    materialType: 'Material Type',
    urgency: 'Urgency',
    channel: 'Channel',
    selectChannel: 'Select channel',
    assignTo: 'Assign To',
    selectMember: 'Select member',
    referenceLink: 'Reference Link',
    reference: 'Reference',
    completedMaterials: 'Completed Materials',
    addMaterialsLink: 'Add Materials Link',
    materialsLinkHint: 'Provide a link to the completed materials (Google Drive, Dropbox, etc.)',
    saveAndComplete: 'Save & Complete',
    adminNotes: 'Admin Notes',
    rejected: 'Rejected',
    poster: 'Poster',
    banner: 'Banner',
    video: 'Video',
    socialMedia: 'Social Media',
    other: 'Other',
    normal: 'Normal',
    urgent: 'Urgent',
    noRequests: 'No requests found',
    newCreativeRequest: 'New Creative Request',
    others: 'Others',

    // CRM Feedback
    crmFeedbackDesc: 'Submit and manage team feedback',
    newFeedback: 'New Feedback',
    feedbackContent: 'What feedback would you like to share?',
    yourFeedback: 'Write your feedback here...',
    noFeedback: 'No feedback found',
    reviewed: 'Reviewed',
    resolved: 'Resolved',
    dismissed: 'Dismissed',

    // Anonymous Wall
    anonymousWallDesc: 'Share your thoughts anonymously',
    submitFeedback: 'Submit Feedback',
    viewFeedback: 'View Feedback',
    writeAnonymously: 'Write your anonymous feedback...',
    feedbackSubmitted: 'Feedback submitted anonymously!',
    noAnonymousFeedback: 'No anonymous feedback yet',
    anonymousFeedbackAdmin: 'Anonymous Feedback (Admin)',

    // Ideas Board
    ideasBoardDesc: 'Share and vote on team ideas',
    newIdea: 'New Idea',
    shareIdea: 'Share your idea...',
    noIdeas: 'No ideas yet',

    // Voting & Polls
    votingPollsDesc: 'Create polls and vote as a team',
    createPoll: 'Create Poll',
    question: 'Question',
    options: 'Options',
    addOption: 'Add Option',
    deadline: 'Deadline',
    noPollsFound: 'No polls found',
    votes: 'votes',
    voted: 'Voted',
    vote: 'Vote',
    expired: 'Expired',
    active: 'Active',

    // Weekly Standup
    weeklyStandupDesc: 'Share your weekly progress',
    submitStandup: 'Submit Standup',
    yesterday: 'Yesterday',
    today: 'Today',
    blockers: 'Blockers',
    whatDidYouDo: 'What did you accomplish?',
    whatWillYouDo: 'What will you work on?',
    anyBlockers: 'Any blockers or issues?',
    noStandups: 'No standups submitted yet',

    // Leaderboard
    leaderboardDesc: 'Team performance rankings',
    points: 'points',
    rank: 'Rank',
    member: 'Member',
    score: 'Score',
    noLeaderboardData: 'No leaderboard data yet',

    // Resource Library
    resourceLibraryDesc: 'Team knowledge base and resources',
    addResource: 'Add Resource',
    resourceTitle: 'Resource title',
    resourceDescription: 'Brief description...',
    resourceLink: 'Resource URL',
    noResources: 'No resources found',
    allCategories: 'All',
    guide: 'Guide',
    template: 'Template',
    tool: 'Tool',

    // Settings
    profileSettings: 'Profile Settings',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    language: 'Language',
    english: 'English',
    malay: 'Bahasa Melayu',

    // Admin
    adminPanel: 'Admin Panel',
    enterPin: 'Enter PIN',
    kpiMetrics: 'KPI Metrics',
    usersRoles: 'Users & Roles',
    ibList: 'List of IB',
    campaigns: 'List of Campaign',
    ideasFeedback: 'Ideas & Feedback',
    comments: 'Comments',
    pic: 'PIC',
    referenceLinks: 'Reference Links',
    completedLinks: 'Completed Links',
    noComments: 'No comments',
    writeComment: 'Write a comment...',
    created: 'Created',
    wellnessTips: 'Wellness Tips',
    yourMoodToday: 'Your Mood Today',
    teamQuotes: 'Team Quotes',
    productIndicator: 'Product / Indicator',
    clientType: 'Client Type',
    usernameTV: 'Username TV',
    telegramId: 'Telegram ID',
    statusIndi: 'Status Indi',
    securityLogs: 'Security Logs',
    exchangeRates: 'Exchange Rates',
    activityLogs: 'Activity Logs',
    reports: 'Reports',
    blocked: 'Blocked',
    unblock: 'Unblock',
  },

  ms: {
    // Common
    save: 'Simpan',
    cancel: 'Batal',
    delete: 'Padam',
    edit: 'Edit',
    submit: 'Hantar',
    search: 'Cari',
    filter: 'Tapis',
    all: 'Semua',
    loading: 'Memuatkan...',
    noData: 'Tiada data tersedia',
    success: 'Berjaya',
    error: 'Ralat',
    confirm: 'Sahkan',
    back: 'Kembali',
    next: 'Seterusnya',
    close: 'Tutup',
    add: 'Tambah',
    update: 'Kemaskini',
    view: 'Lihat',
    from: 'Dari',
    to: 'Kepada',
    date: 'Tarikh',
    status: 'Status',
    actions: 'Tindakan',
    description: 'Penerangan',
    title: 'Tajuk',
    category: 'Kategori',
    priority: 'Keutamaan',
    type: 'Jenis',
    note: 'Nota',
    optional: 'pilihan',

    // Auth
    login: 'Log Masuk',
    logout: 'Log Keluar',
    email: 'Emel',
    password: 'Kata Laluan',
    forgotPassword: 'Lupa kata laluan?',
    loginSuccess: 'Log masuk berjaya!',
    invalidCredentials: 'Maklumat log masuk tidak sah',
    systemActive: 'SISTEM AKTIF',

    // Sidebar & Nav
    dashboard: 'UA Dashboard',
    myTasks: 'Tugas Saya',
    ibManagement: 'Pengurusan IB',
    teamSpace: 'Ruang Pasukan',
    settings: 'Tetapan',
    uaResourceLibrary: 'Perpustakaan Sumber UA',
    announcements: 'Pengumuman',
    dailyEcstasy: 'Daily Ecstasy',
    ideasBoard: 'Papan Idea',
    anonymousWall: 'Dinding Anonim',
    crmFeedback: 'Maklum Balas CRM',
    creativeRequest: 'Permintaan Kreatif',
    votingPolls: 'Undian & Poll',
    weeklyStandup: 'Standup Mingguan',
    leaderboard: 'Papan Pendahulu',

    // Dashboard
    overallPerformance: 'Prestasi Keseluruhan',
    executiveDashboard: 'Papan Pemuka Eksekutif',
    allIBsCombined: 'Semua IB Digabungkan',
    performanceProjections: 'Unjuran Prestasi',
    endOfMonthForecast: 'Ramalan Akhir Bulan',
    keyMetricsScorecard: 'Kad Skor Metrik Utama',
    baseScenario: 'Senario Asas',
    endOfMonth: 'Akhir Bulan',
    current: 'SEMASA',
    target: 'SASARAN',
    surplus: 'lebihan',
    shortfall: 'kekurangan',
    projectedSubscribers: 'Unjuran Pelanggan',
    projectedLeads: 'Unjuran Leads',
    projectedClosed: 'Unjuran Closed',
    projectedActiveClient: 'Unjuran Klien Aktif',
    projectedTradedLot: 'Unjuran Traded Lot',
    projectedCommissions: 'Unjuran Komisen',
    totalSpend: 'JUMLAH PERBELANJAAN',
    impressions: 'IMPRESI',
    linkClicks: 'KLIK PAUTAN',
    lpv: 'LPV',
    ctaClicks: 'KLIK CTA',
    subscribers: 'PELANGGAN',
    leads: 'LEADS',
    closed: 'CLOSED',
    deposit: 'DEPOSIT',
    signal: 'SIGNAL',
    ibActivity: 'AKTIVITI IB',
    activeClient: 'KLIEN AKTIF',
    tradedLot: 'LOT DAGANGAN',
    commissions: 'KOMISEN',
    roi: 'ROI',
    noDataAvailable: 'Tiada data tersedia',

    // My Tasks
    managePersonalTasks: 'Urus tugas peribadi anda',
    addTask: 'Tambah Tugas',
    allTasks: 'Semua Tugas',
    pending: 'Belum Selesai',
    inProgress: 'Sedang Berjalan',
    completed: 'Selesai',
    tasks: 'Tugas',
    assignedToMe: 'Ditugaskan Kepada Saya',
    calendar: 'Kalendar',
    month: 'Bulan',
    list: 'Senarai',
    searchTasks: 'Cari tugas...',
    noTasksFound: 'Tiada tugas ditemui',
    noTasksAssigned: 'Tiada tugas ditugaskan kepada anda',
    assignedTasksHint: 'Permintaan kreatif yang ditugaskan kepada anda akan muncul di sini',
    noTasksScheduled: 'Tiada tugas dijadualkan untuk',
    enterTaskTitle: 'Masukkan tajuk tugas',
    optionalDescription: 'Penerangan pilihan...',
    addNewTask: 'Tambah Tugas Baru',
    low: 'Rendah',
    medium: 'Sederhana',
    high: 'Tinggi',
    general: 'Umum',
    work: 'Kerja',
    meeting: 'Mesyuarat',
    personal: 'Peribadi',
    dueDate: 'Tarikh Akhir',

    // Daily Ecstasy
    checkInMoodAndQuotes: 'Semak mood anda & kongsi petikan inspirasi',
    moodCheckIn: 'Semakan Mood',
    howAreYouFeeling: 'Bagaimana perasaan anda hari ini?',
    submitted: 'Telah Dihantar',
    addNote: 'Tambah nota (pilihan)...',
    submitMood: 'Hantar Mood',
    updateMood: 'Kemaskini Mood',
    quoteOfTheDay: 'Petikan Hari Ini',
    noQuoteToday: 'Tiada petikan dipilih untuk hari ini',
    shareQuote: 'Kongsi petikan inspirasi:',
    enterQuote: 'Masukkan petikan anda...',
    teamQuotesToday: 'Petikan pasukan hari ini:',
    selected: 'Terpilih',
    great: 'Hebat',
    good: 'Baik',
    okay: 'Biasa',
    stressed: 'Tekanan',
    bad: 'Teruk',

    // Announcements
    teamAnnouncements: 'Pengumuman Pasukan',
    stayUpdated: 'Kekal terkini dengan berita pasukan',
    newAnnouncement: 'Pengumuman Baru',
    pinned: 'Disemat',
    announcementTitle: 'Tajuk pengumuman',
    writeAnnouncement: 'Tulis pengumuman anda...',
    pinAnnouncement: 'Semat pengumuman ini',
    post: 'Hantar',
    noAnnouncements: 'Tiada pengumuman lagi',

    // Creative Request
    orderMaterials: 'Tempah bahan dari pasukan kreatif',
    newRequest: 'Permintaan Baru',
    materialType: 'Jenis Bahan',
    urgency: 'Keutamaan',
    channel: 'Saluran',
    selectChannel: 'Pilih saluran',
    assignTo: 'Tugaskan Kepada',
    selectMember: 'Pilih ahli',
    referenceLink: 'Pautan Rujukan',
    reference: 'Rujukan',
    completedMaterials: 'Bahan Siap',
    addMaterialsLink: 'Tambah Pautan Bahan',
    materialsLinkHint: 'Berikan pautan ke bahan siap (Google Drive, Dropbox, dll.)',
    saveAndComplete: 'Simpan & Selesai',
    adminNotes: 'Nota Admin',
    rejected: 'Ditolak',
    poster: 'Poster',
    banner: 'Banner',
    video: 'Video',
    socialMedia: 'Media Sosial',
    other: 'Lain-lain',
    normal: 'Biasa',
    urgent: 'Segera',
    noRequests: 'Tiada permintaan ditemui',
    newCreativeRequest: 'Permintaan Kreatif Baru',
    others: 'Lain-lain',

    // CRM Feedback
    crmFeedbackDesc: 'Hantar dan urus maklum balas pasukan',
    newFeedback: 'Maklum Balas Baru',
    feedbackContent: 'Apakah maklum balas yang ingin anda kongsi?',
    yourFeedback: 'Tulis maklum balas anda di sini...',
    noFeedback: 'Tiada maklum balas ditemui',
    reviewed: 'Disemak',
    resolved: 'Diselesaikan',
    dismissed: 'Ditolak',

    // Anonymous Wall
    anonymousWallDesc: 'Kongsi fikiran anda secara anonim',
    submitFeedback: 'Hantar Maklum Balas',
    viewFeedback: 'Lihat Maklum Balas',
    writeAnonymously: 'Tulis maklum balas anonim anda...',
    feedbackSubmitted: 'Maklum balas dihantar secara anonim!',
    noAnonymousFeedback: 'Tiada maklum balas anonim lagi',
    anonymousFeedbackAdmin: 'Maklum Balas Anonim (Admin)',

    // Ideas Board
    ideasBoardDesc: 'Kongsi dan undi idea pasukan',
    newIdea: 'Idea Baru',
    shareIdea: 'Kongsi idea anda...',
    noIdeas: 'Tiada idea lagi',

    // Voting & Polls
    votingPollsDesc: 'Cipta undian dan undi bersama pasukan',
    createPoll: 'Cipta Undian',
    question: 'Soalan',
    options: 'Pilihan',
    addOption: 'Tambah Pilihan',
    deadline: 'Tarikh Akhir',
    noPollsFound: 'Tiada undian ditemui',
    votes: 'undi',
    voted: 'Telah Undi',
    vote: 'Undi',
    expired: 'Tamat Tempoh',
    active: 'Aktif',

    // Weekly Standup
    weeklyStandupDesc: 'Kongsi kemajuan mingguan anda',
    submitStandup: 'Hantar Standup',
    yesterday: 'Semalam',
    today: 'Hari Ini',
    blockers: 'Halangan',
    whatDidYouDo: 'Apa yang anda telah capai?',
    whatWillYouDo: 'Apa yang akan anda kerjakan?',
    anyBlockers: 'Ada halangan atau isu?',
    noStandups: 'Tiada standup dihantar lagi',

    // Leaderboard
    leaderboardDesc: 'Kedudukan prestasi pasukan',
    points: 'mata',
    rank: 'Kedudukan',
    member: 'Ahli',
    score: 'Skor',
    noLeaderboardData: 'Tiada data papan pendahulu lagi',

    // Resource Library
    resourceLibraryDesc: 'Pangkalan pengetahuan dan sumber pasukan',
    addResource: 'Tambah Sumber',
    resourceTitle: 'Tajuk sumber',
    resourceDescription: 'Penerangan ringkas...',
    resourceLink: 'URL Sumber',
    noResources: 'Tiada sumber ditemui',
    allCategories: 'Semua',
    guide: 'Panduan',
    template: 'Templat',
    tool: 'Alat',

    // Settings
    profileSettings: 'Tetapan Profil',
    appearance: 'Penampilan',
    darkMode: 'Mod Gelap',
    lightMode: 'Mod Cerah',
    language: 'Bahasa',
    english: 'English',
    malay: 'Bahasa Melayu',

    // Admin
    adminPanel: 'Panel Admin',
    enterPin: 'Masukkan PIN',
    kpiMetrics: 'Metrik KPI',
    usersRoles: 'Pengguna & Peranan',
    ibList: 'Senarai IB',
    campaigns: 'Senarai Kempen',
    ideasFeedback: 'Idea & Maklum Balas',
    comments: 'Komen',
    pic: 'PIC',
    referenceLinks: 'Pautan Rujukan',
    completedLinks: 'Pautan Siap',
    noComments: 'Tiada komen',
    writeComment: 'Tulis komen...',
    created: 'Dicipta',
    wellnessTips: 'Tips Kesejahteraan',
    yourMoodToday: 'Mood Anda Hari Ini',
    teamQuotes: 'Petikan Pasukan',
    productIndicator: 'Produk / Indikator',
    clientType: 'Jenis Klien',
    usernameTV: 'Username TV',
    telegramId: 'Telegram ID',
    statusIndi: 'Status Indi',
    securityLogs: 'Log Keselamatan',
    exchangeRates: 'Kadar Tukaran',
    activityLogs: 'Log Aktiviti',
    reports: 'Laporan',
    blocked: 'Disekat',
    unblock: 'Nyahsekat',
  }
};

export default translations;
